import type { Signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs';

/**
 * Debounces the signal by the given duration.
 * As signals should always have a value, the value of the initial signal is set to be the value of the debounced signal without delay.
 * This means that the initial value is not debounced
 */
export function debouncedSignal<T>(signal: Signal<T>, debounceTimeMs: number): Signal<T> {
    return toSignal(toObservable(signal).pipe(debounceTime(debounceTimeMs)), {
        initialValue: signal()
    });
}
